'use client'

import { useErrorHandler, useTranslate } from '@repo/shared/hooks'
import { useDeleteAgentBank, useSetDefaultAgentBank } from '@repo/services'
import {
  Button,
  Icon,
  Typography,
  UI_DropdownDrawer,
  Modal,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalTitle,
} from '@repo/ui/components'
import { Card } from './cards.container'
import { useState } from 'react'
import Image from 'next/image'
import { onCloseDrawer } from '@repo/ui/components'

export const CardsItemAction = ({ data }: { data: Card }) => {
  const { errorHandler } = useErrorHandler()
  const { t } = useTranslate()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const deleteBankMutation = useDeleteAgentBank({ invalidate: true })
  const setDefaultBankMutation = useSetDefaultAgentBank({ invalidate: true })

  const handleDelete = () => {
    if (data.id) {
      deleteBankMutation.mutate([data.id].join(',') as never, {
        onSuccess: () => {
          deleteBankMutation.reset()
          setIsDeleteModalOpen(false)
          onCloseDrawer()
        },
        onError: (error) => errorHandler(error, { type: 'toast' }),
      })
    }
  }

  const handleSetDefault = () => {
    if (data.id) {
      setDefaultBankMutation.mutate(
        {
          bankID: data.id,
        },
        {
          onSuccess: () => {
            setDefaultBankMutation.reset()
            onCloseDrawer()
          },
          onError: (error) => errorHandler(error, { type: 'toast' }),
        },
      )
    }
  }

  const handleModalOpenChange = (open: boolean) => {
    if (!open) {
      setIsDeleteModalOpen(false)
    } else {
      setIsDropdownOpen(false)
      setIsDeleteModalOpen(true)
    }
  }
  const handleDropdownOpenChange = (open: boolean) => {
    if (!open) {
      setIsDropdownOpen(false)
    } else {
      setIsDropdownOpen(true)
    }
  }
  return (
    <>
      <UI_DropdownDrawer
        cancelButtonLabel={t('action_cancel')}
        items={[
          {
            label: (
              <Typography size='sm' weight='bold'>
                {t('addCardPage_default_action')}
              </Typography>
            ),
            onClick: handleSetDefault,
          },
          {
            label: (
              <Typography
                size='sm'
                weight='bold'
                color='text-negative-surface-100'
              >
                {t('addCardPage_delete_action')}
              </Typography>
            ),
            onClick: () => handleModalOpenChange(true),
          },
        ]}
        open={isDropdownOpen}
        onOpenChange={handleDropdownOpenChange}
      >
        <Button
          variant='transparent'
          size='xs'
          color='base'
          startIcon={
            <Icon name='TripleDotsHorizontal' size='xs' color='fill-current' />
          }
          aria-label='More Options'
        />
      </UI_DropdownDrawer>

      <Modal open={isDeleteModalOpen} onOpenChange={handleModalOpenChange}>
        <ModalContent className='sm:max-w-[425px]'>
          <ModalHeader>
            <ModalTitle />
          </ModalHeader>
          <Image
            src='/images/danger.png'
            alt='cancel-withdraw'
            width={64}
            height={64}
            className='mx-auto'
          />
          <Typography
            size='sm'
            color='text-negative-surface-100'
            className='text-center'
          >
            {t('addCardPage_delete_confirm_description')}
          </Typography>
          <ModalFooter className='flex flex-col'>
            <Button
              variant='fill'
              color='negative'
              onClick={handleDelete}
              loading={deleteBankMutation.isPending}
              disabled={deleteBankMutation.isPending}
              className='w-full'
            >
              {t('addCardPage_delete_action')}
            </Button>
            <Button
              variant='transparent'
              color='neutral'
              onClick={() => handleModalOpenChange(false)}
              disabled={deleteBankMutation.isPending}
              className='w-full '
            >
              {t('action_cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
